// extracted by mini-css-extract-plugin
export var cartContainer = "_mz-4";
export var gray = "_mz-1";
export var itemContainer = "_mz-2";
export var itemDetails = "_mz-3";
export var strong = "_mz-0";